import(/* webpackMode: "eager" */ "/home/ubuntu/download/69adfd40886e10001451db07/haalproject/src/app/subhaal/masjid-al-ihsan/events/page.tsx");
